if (!customElements.get('hide-description')) {
class HideDescription extends HTMLElement {
  constructor() {
    super();

    this.truncatedText = this.querySelector(".truncated-description");
    this.fullText = this.querySelector(".full-description");

    this.showMoreButton = this.querySelector(".show-more");
    this.showLessButton = this.querySelector(".show-less");
  }

  connectedCallback() {
      this.showMoreButton.addEventListener('click', this.handleShowMore.bind(this));
      this.showLessButton.addEventListener('click', this.handleShowLess.bind(this));
  }

  handleShowMore() {
    this.truncatedText.classList.add('visually-hidden');
    this.fullText.classList.remove('visually-hidden');
    this.showMoreButton.classList.add('visually-hidden');
    this.showLessButton.classList.remove('visually-hidden');
  }
  handleShowLess() {
    this.truncatedText.classList.remove('visually-hidden');
    this.fullText.classList.add('visually-hidden');
    this.showMoreButton.classList.remove('visually-hidden');
    this.showLessButton.classList.add('visually-hidden');
  }

}

customElements.define('hide-description', HideDescription);

}